import React from "react";
import { 
  TableRow, 
  TableCell, 
  Box, 
  Typography, 
  Avatar 
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox"; 
import ActivityBar from "../../../components/ReportsDateActivity/ActivityBar";

const cellStyle = {
  padding: '10px 16px',
};

const getInitials = (name) => {
  const names = name.split(" ");
  return names.map(n => n[0]).join("").toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 60%, 60%)`;
  return color;
};


const MemberRowMe = ({ row, isSelected, onSelectToggle }) => {
  return (
    <TableRow sx={{
      '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
      backgroundColor: '#fff',
      borderRadius: '10px',
      transition: 'box-shadow 0.3s ease',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        {row.id}
      </TableCell>  
    <TableCell sx={{
  ...cellStyle,
  border: 'none',
  color: '#626262',
  backgroundColor: '#fff',
  textAlign: 'left'
}}>
  <Box display="flex" alignItems="center" gap={1}>
    <Avatar
      sx={{
        width: '40px',
        height: '40px',
        fontSize: '13px',
        bgcolor: stringToColor(row.projectName),
      }}
    >
      {getInitials(row.projectName)}
    </Avatar>
    <Box>
      <Typography fontWeight="bold">{row.projectName}</Typography>
      <Typography variant="body2" color="text.secondary">
        {row.projectRole}
      </Typography>
    </Box>
  </Box>
</TableCell>



      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
       <ActivityBar activity={row.activity} /> 
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        ${row.currentRate}
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.totalHours}
      </TableCell>

       
     

      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        textAlign: 'center',
        borderRadius: '0px 10px 10px 0px' 
      }}>
        <Typography color="primary" sx={{ cursor: "pointer" }}>
          ${row.totalAmount}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default MemberRowMe;
